import "./Footer1.css";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

const Footer1 = () => {
    const [openDropdowns, setOpenDropdowns] = useState([]);
    const navigate = useNavigate();

    const toggleDropdown = (section) => {
        setOpenDropdowns((prev) =>
            prev.includes(section)
                ? prev.filter((item) => item !== section)
                : [...prev, section]
        );
    };

    const isOpen = (section) => openDropdowns.includes(section);

    return (
        <footer className="footer-wrapper">
            {/* 1. Newsletter Section */}
            <div className="footer-top">
                <div className="newsletter-content">
                    <h3>Join the Inner Circle</h3>
                    <p>Subscribe for exclusive exhibition invites and new series drops.</p>
                    <div className="newsletter-form">
                        <input type="email" placeholder="Enter your email address" />
                        <button className="btn-arrow">
                            <i className="fa-solid fa-arrow-right"></i>
                        </button>
                    </div>
                </div>
            </div>

            {/* 2. Main Links Grid */}
            <div className="footer-grid">

                {/* Column 1: Brand / About */}
                <div className="footer-col brand-col">
                    <h4 className="footer-logo">ANJAAN VIVEK</h4>
                    <p className="brand-desc">
                        Innovating contemporary art through pictorial biographies and masterwork anthologies.
                    </p>
                    <div className="social-icons">
                        <a href="https://www.instagram.com/anjaanvivek_art/" target="_blank" className="social-icon"><i className="fa-brands fa-instagram"></i></a>
                        {/* <a href="https://www.facebook.com/vivek.verma.590410" target="_blank" className="social-icon"><i className="fa-brands fa-facebook-f"></i></a> */}
                        <a href="https://x.com/anjaanVivek" target="_blank" className="social-icon"><i className="fa-brands fa-twitter"></i></a>
                        {/* <a href="https://pinterest.com" target="_blank" rel="noreferrer"><i className="fa-brands fa-pinterest"></i></a> */}
                    </div>
                </div>

                {/* Column 2: Explore (Accordion on Mobile) */}
                <div className="footer-col">
                    <div className="col-header" onClick={() => toggleDropdown("explore")}>
                        <h4>Explore</h4>
                        <i className={`fa-solid fa-chevron-down mobile-only ${isOpen("explore") ? "rotate" : ""}`}></i>
                    </div>
                    <ul className={`footer-links-list ${isOpen("explore") ? "open" : ""}`}>
                        <li onClick={() => navigate("/allpaintings/All Paintings")}>All Paintings</li>
                        <li onClick={() => navigate("/worldFrameSeries")}>The World Frame Series</li>
                        <li onClick={() => navigate("/allprints")}>Archival Prints</li>
                        {/* <li onClick={() => navigate("/exhibitions")}>Exhibitions</li> */}
                    </ul>
                </div>

                {/* Column 3: The Artist (Accordion on Mobile) */}
                <div className="footer-col">
                    <div className="col-header" onClick={() => toggleDropdown("company")}>
                        <h4>The Artist</h4>
                        <i className={`fa-solid fa-chevron-down mobile-only ${isOpen("company") ? "rotate" : ""}`}></i>
                    </div>
                    <ul className={`footer-links-list ${isOpen("company") ? "open" : ""}`}>
                        <li onClick={() => navigate("/about")}>About the Artist</li>
                        {/* <li onClick={() => navigate("/projects")}>Projects</li> */}
                        <li onClick={() => navigate("/customBiography")}>Custom Biography Art</li>
                        <li onClick={() => navigate("/contact")}>Contact Concierge</li>
                    </ul>
                </div>

                {/* Column 4: Support & Concierge (Accordion on Mobile) */}
                <div className="footer-col">
                    <div className="col-header" onClick={() => toggleDropdown("legal")}>
                        <h4>Support</h4>
                        <i className={`fa-solid fa-chevron-down mobile-only ${isOpen("legal") ? "rotate" : ""}`}></i>
                    </div>
                    <ul className={`footer-links-list ${isOpen("legal") ? "open" : ""}`}>
                        <li onClick={() => navigate("/cart")}>Portfolio & Cart</li>
                        {/* <li onClick={() => navigate("/wishlist")}>Collector Wishlist</li>
                        <li onClick={() => navigate("/myOrders")}>Acquisition Orders</li> */}
                        <li className="contact-highlight" onClick={() => window.location.href = "tel:+919300847841"}>+91 9300847841</li>
                    </ul>
                </div>
            </div>

            {/* 3. Big Watermark Text */}
            <div className="footer-watermark">
                <h1>ANJAAN ART</h1>
            </div>

            {/* 4. Bottom Bar */}
            <div className="footer-bottom">
                <p>© 2026 Anjaan Vivek Studio. All Rights Reserved.</p>
                <p>Designed for Fine Art Collectors</p>
            </div>
        </footer>
    );
};

export default Footer1;